import { GraphQLInputObjectType, GraphQLNonNull, GraphQLID } from 'graphql'

interface SlidingTutorialMarkArg {
  readonly orgUuid: string
  readonly tutorialKey: string
}

const SlidingTutorialMarkArgType = new GraphQLInputObjectType({
  name: 'SlidingTutorialMarkArg',
  description:
    'Parameters that describe an update to mark as viewed an sliding tutorial page',
  fields: () => ({
    orgUuid: {
      description: 'The ID of the organization.',
      type: new GraphQLNonNull(GraphQLID)
    },
    tutorialKey: {
      description: 'The key of the tutorial page that will be marked as viewed',
      type: new GraphQLNonNull(GraphQLID)
    }
  })
})

export interface SlidingTutorialMarkArgs {
  readonly input?: SlidingTutorialMarkArg
}

export const slidingTutorialMarkArgs = {
  input: {
    type: SlidingTutorialMarkArgType
  }
}
